import React from "react";
import { Link } from "react-router-dom";
import NavbarMenu from "../../components/NavbarMenu";

export default function MenuLanding() {
  return (
    <div className="relative min-h-screen bg-gradient-to-br from-[#050505] via-[#111111] to-[#2b1a10] text-white overflow-hidden">

      {/* NAVBAR FIJO */}
      <NavbarMenu />

      {/* CONTENIDO PRINCIPAL */}
      <div className="max-w-xl space-y-8 pt-40 md:pt-36 relative z-20 text-center mx-auto px-6">

        {/* TÍTULO */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight">
          El sabor que te <br />
          <span className="text-orange-400 drop-shadow-[0_0_25px_rgba(251,146,60,0.5)]">
            Hace Feliz.
          </span>
        </h1>

        {/* HORARIO */}
        <div className="space-y-1 text-base md:text-lg">
          <h3 className="text-xl font-semibold flex justify-center gap-2">
            ⏰ Horario
          </h3>
          <p className="text-green-400 font-bold">Abierto 24 horas</p>
        </div>

        {/* BOTÓN PRINCIPAL (CAMBIADO) */}
        <div className="flex justify-center">
          <Link
            to="/pedido"
            className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 px-6 py-3 rounded-xl 
                       text-base md:text-lg font-semibold text-black shadow-[0_1.5rem_2rem_rgba(0,0,0,0.6)] 
                       transition-transform hover:-translate-y-1"
          >
            🛒 Haz tu pedido
          </Link>
        </div>

        {/* ==============================
              ÍCONOS DE CONTACTO
           ============================== */}
        <div className="w-full flex flex-col items-center mt-10">

          <div className="grid grid-cols-2 md:grid-cols-4 gap-10 text-center">

            {/* WhatsApp */}
            <a
              href="https://api.whatsapp.com/send/?phone=573017400249"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center"
            >
              <img
                src="/icons/whatsapp.svg"
                className="w-9 h-9 hover:scale-110 transition"
              />
              <span className="text-gray-400 text-sm mt-1 animate-pulse">
                WhatsApp
              </span>
            </a>

            {/* Ubicación */}
            <a
              href="https://maps.app.goo.gl/ptGjkTr8FyLCkToJ9"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center"
            >
              <img
                src="/icons/location.svg"
                className="w-9 h-9 hover:scale-110 transition"
              />
              <span className="text-gray-400 text-sm mt-1 animate-pulse">
                Cómo llegar
              </span>
            </a>

            {/* Facebook */}
            <a
              href="https://www.facebook.com/share/1DJnijTbwY/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center"
            >
              <img
                src="/icons/facebook.svg"
                className="w-9 h-9 hover:scale-110 transition"
              />
              <span className="text-gray-400 text-sm mt-1 animate-pulse">
                Facebook
              </span>
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/delistumerienda?igsh=MXg5d2Q4NDM4MWhuYQ=="
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center"
            >
              <img
                src="/icons/instagram.svg"
                className="w-9 h-9 hover:scale-110 transition"
              />
              <span className="text-gray-400 text-sm mt-1 animate-pulse">
                Instagram
              </span>
            </a>

          </div>
        </div>
      </div>
    </div>
  );
}
